// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('UploadImageModalDropIndicator')

function UploadImageModalDropIndicator(props) {
  return tag('div', {
    className: classNames(
      props.className,
      bem.block({
        visible: props.isVisible
      })
    )
  },
    'Drop to Preview'
  )
}

UploadImageModalDropIndicator.propTypes = {
  className: PropTypes.string,
  isVisible: PropTypes.bool
}

module.exports = UploadImageModalDropIndicator
